export default __webpack_public_path__ + "assets/71e8335140fe8ad433559f91d74a998e.svg";